import { useMutation, useQuery } from '@tanstack/react-query';
import usersService from '~/services/usersService/users.service';
import useUserContext from './useUserContext';

export const usePublicProfile = (username: string) => {
  const { user, updateUserOnClient } = useUserContext();

  const { data: profile, isLoading, error, } = useQuery({
    queryKey: ['publicProfile', username],
    queryFn: () => usersService.getPublicProfile(username),
    enabled: !!username,
  });

  const followMutation = useMutation({
    mutationFn: (userId: string) => usersService.followUser(userId),
    onSuccess: (data) => {
      updateUserOnClient({
        followedUserIdList: [...(user?.followedUserIdList ?? []), data.followingId],
      });
    },
  });

  const unfollowMutation = useMutation({
    mutationFn: (userId: string) => usersService.unfollowUser(userId),
    onSuccess: (data) => {
      updateUserOnClient({
        followedUserIdList: user?.followedUserIdList?.filter((id) => id !== data.followingId),
      });
    },
  });

  return {
    profile,
    isLoading,
    error,
    followUser: followMutation.mutate,
    unfollowUser: unfollowMutation.mutate,
    isFollowLoading: followMutation.isPending,
    isUnfollowLoading: unfollowMutation.isPending,
  };
}; 